<mat-tab-group>
    <mat-tab>
        <ng-template mat-tab-label>
            <span>Ajouter un litige</span>

        </ng-template>
        <div class="o-hidden mt-4" style="margin:20px">
            <form [formGroup]="Formcar" autocomplete="off" (ngSubmit)="onInfoFormCoordonneesSubmit()">

                <div fxLayout="row wrap" class="flex-wrapper">
                    <mat-form-field fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-label>Vehicule</mat-label>
                        <mat-select placeholder="choisir un vehicule" formControlName="vehicule"
                            (selectionChange)="resevationVehicule()" required>
                            <mat-option *ngFor="let item of Car" [value]="item.id">
                                {{item.vehicle_mark}},{{item.vehicle_model}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-label>Reservation</mat-label>
                        <mat-select placeholder="choisir un vehicule" name="reservation" formControlName="reservation"
                            required>

                            <mat-option>
                                <span style="margin-right:5px;font-weight: bloder" *ngIf="idVehicule">Date de
                                    départ</span>
                                <span style="margin-left:25px;font-weight: bloder" *ngIf="idVehicule">Date de retour
                                </span>
                                <span *ngIf="idVehicule == null || idVehicule == undefined">Veillez selectionner un
                                    véhicule</span>
                            </mat-option>
                            <mat-option *ngFor="let reservation of rentings" [value]="reservation.id">
                                <span style="margin-right:5px">{{reservation.renting_date_departure
                                    |date:'mediumDate'}}</span>
                                <span style="margin-left:26px">{{reservation.renting_date_return |date:'mediumDate'}}
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-hint>Champs Obligatoire *</mat-hint>
                    </mat-form-field>
                </div>
                <div fxLayout="row wrap" class="flex-wrapper">
                    <div fxFlex="100" fxFlex.gt-sm="100" class="px-3">
                        <div class="container">
                            <div class="row">
                                <div class="o-hidden mt-4">
                                    <div fxLayout="row wrap">
                                        <h4> Decrivez votre litige.</h4>

                                        <div fxFlex="100" class="px-3">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Decrivez votre litige.
                                                </mat-label>
                                                <textarea matInput
                                                    placeholder="vehicule_description (street, apartment, suite, unit etc.)"
                                                    formControlName="litige_description" rows="9"></textarea>

                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div fxLayout="row wrap" class="flex-wrapper">
                    <div fxFlex="100" fxFlex.gt-sm="30" class="px-3">
                        <mat-checkbox formControlName="validcondition" color="primary">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <span class="mr-1">Accepter les conditions</span>

                            </div>
                        </mat-checkbox>
                    </div>
                </div><br>

                <div fxLayout="row wrap" class="flex-wrapper">
                    <div fxFlex="100" fxFlex.gt-sm="30" class="px-3">
                        <div class="text-center">
                            <button mat-raised-button color="primary" type="submit" class="w-100 uppercase"><span
                                    class="px-3 uppercase">Enregistrer</span></button>
                        </div>
                    </div>
                </div>




            </form>
        </div>
    </mat-tab>
</mat-tab-group>